import { inject, Injectable } from '@angular/core';
import { AppEnvironmentConfig } from 'projects/config/model/environment.config.model';
import { Observable } from 'rxjs';
import { OutlookIntegrationHttpClient } from './outlook-integration-http-client';
import { OutlookConnectionStatus, OutlookDeactivationResult, OutlookEligibleActionPlans, OutlookIntegrationState } from '../models/outlook-integration.types';

@Injectable({
  providedIn: 'root',
})
export class OutlookIntegrationApiService {
  private readonly _httpClient = inject(OutlookIntegrationHttpClient);
  private readonly _appConfig = inject(AppEnvironmentConfig);

  public get oauthStartUrl(): string {
    return `${this._appConfig.APIs.apiUrlActionPlan}/outlook/oauth/start`;
  }

  public getStatus(): Observable<OutlookIntegrationState> {
    return this._httpClient.get<OutlookIntegrationState>('/OutlookIntegration');
  }

  public getConnectionStatus(): Observable<OutlookConnectionStatus> {
    return this._httpClient.get<OutlookConnectionStatus>('/OutlookIntegration/Connection');
  }

  public getEligibleActionPlans(): Observable<OutlookEligibleActionPlans> {
    return this._httpClient.get<OutlookEligibleActionPlans>('/OutlookIntegration/EligibleActionPlanCount');
  }

  public syncHistory(): Observable<void> {
    return this._httpClient.post<void>('/OutlookIntegration/HistorySync', {});
  }

  public deactivate(): Observable<OutlookDeactivationResult> {
    return this._httpClient.delete<OutlookDeactivationResult>('/OutlookIntegration');
  }
}
